import { useMemo } from "react";

import { useBandContext } from "Bands/contexts";
import {
  DateFormat,
  TimeFormat,
} from "shared/utils/getRegionalSettingsOptions";

const DEFAULT_TIME_FORMAT = TimeFormat.twentyFour;
const DEFAULT_DATE_FORMAT = DateFormat.dmy;

export const useBandRegionalSettings = () => {
  const { band } = useBandContext();

  const { dateFormat, timeFormat, timeZone } = useMemo(
    () => ({
      dateFormat: band?.dateFormat || DEFAULT_DATE_FORMAT,
      timeFormat: band?.timeFormat || DEFAULT_TIME_FORMAT,
      timeZone: band?.timeZone || null,
    }),
    [band]
  );

  return {
    dateFormat,
    timeFormat,
    timeZone,
  };
};
